<template>
    <div 
        class="plan-item-button" 
        :class="{ 
            selected: isSelected, 
            disabled: disabled || loading 
        }" 
        @click="handleClick"
    >
        <a-spin v-if="loading" size="small" style="margin-right: 4px;" />
        <slot />
    </div>
</template>
<script>
/**
 * PlanItemButton Component
 * Fatura işlemleri için kullanılan buton component'i
 * 
 * @prop {Boolean} isSelected - Butonun seçili olup olmadığını belirtir
 * @prop {Boolean} disabled - Butonun devre dışı olup olmadığını belirtir
 * @prop {Boolean} loading - Butonun loading durumunda olup olmadığını belirtir
 */
export default {
    name: "PlanItemButton",
    props: {
        isSelected: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        /**
         * Click event handler
         * Disabled veya loading durumunda click event'ini engeller
         */
        handleClick() {
            if (this.disabled || this.loading) {
                return;
            }
            this.$emit('click');
        },
    },
};
</script>
<style lang="scss" scoped>
.plan-item-button {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 12px;
    border-radius: 16px;
    cursor: pointer;
    background: #F1F4F7;
    border: 1px solid #F1F4F7;
    color: #222222;
    gap: 5px;
    font-size: 12px;
    white-space: nowrap;

    &:hover {
        background: #1C1B1F;
        border: 1px solid #1C1B1F;
        color: white;

        .material-icons {
            color: white;
        }
    }

    &.selected {
        background: #F1F4F7;
        border: 1px solid #E4D7FF;
        color: #5625CC;

        .material-icons {
            color: #5625CC;
        }
    }

    .material-icons {
        font-size: 16px;
        color: #222222;
    }

    &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;

        &:hover {
            background: #F1F4F7;
            border: 1px solid #F1F4F7;
            color: #222222;

            .material-icons {
                color: #222222;
            }
        }
    }
}
</style>
